import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useSinkRef } from "../utils/sink";

export const PrimaryCTA = ({ to, href, children, testid, dark = false, className = "" }) => {
  const sinkRef = useSinkRef();
  const cls = `sink-target group inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 text-sm sm:text-base font-bold uppercase tracking-wide transition-all duration-300 ${
    dark
      ? "bg-volt text-[#0B111B] hover:bg-accent hover:text-[#EDF1F7]"
      : "bg-accent text-[#EDF1F7] hover:bg-volt hover:text-[#0B111B]"
  } ${className}`;
  const inner = (
    <>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl:-scale-x-100" />
    </>
  );
  return to ? (
    <Link ref={sinkRef} to={to} data-testid={testid} className={cls}>{inner}</Link>
  ) : (
    <a ref={sinkRef} href={href} data-testid={testid} className={cls}>{inner}</a>
  );
};

export const GhostCTA = ({ to, href, children, testid, dark = false, className = "" }) => {
  const sinkRef = useSinkRef();
  const cls = `sink-target group inline-flex items-center gap-2.5 rounded-full border px-7 py-3.5 text-sm sm:text-base font-bold uppercase tracking-wide transition-colors duration-300 ${
    dark
      ? "border-ink/30 text-ink hover:border-volt hover:text-volt"
      : "border-ink/25 text-ink hover:border-cyan hover:text-cyan"
  } ${className}`;
  const inner = (
    <>
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 rtl:-scale-x-100" />
    </>
  );
  return to ? (
    <Link ref={sinkRef} to={to} data-testid={testid} className={cls}>{inner}</Link>
  ) : (
    <a ref={sinkRef} href={href} data-testid={testid} className={cls}>{inner}</a>
  );
};
